let language = {

    POP_UP_BUTTON_OK: "好的",
    POP_UP_BUTTON_CANCEL: "取消",
    POP_UP_BUTTON_SUBMIT: "提交",
    POP_UP_BUTTON_ENABLE: "允许",
    POP_UP_BUTTON_SURE: "确定",

};

export { language }